import _default from './Transition';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/modules/Transition/index.js
// module id = 289
// module chunks = 0